import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { caricaGA, gaConsentito, gaPageView } from '../utils/analytics';

// Carica GA (se c'è il consenso) e traccia le pagine viste sui cambi di route.
function Analytics() {
  const location = useLocation();

  // Al primo mount, se il consenso c'è già, carica GA.
  useEffect(() => {
    if (gaConsentito()) caricaGA();
  }, []);

  // Ogni cambio pagina → page_view (no-op finché GA non è caricato).
  useEffect(() => {
    gaPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return null;
}

export default Analytics;
